
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.899 2.1L7.333.668 6.767 2.1l-1.434.566 1.434.565.566 1.434.566-1.434 1.434-.566L7.9 2.102zm4.1 5.233h2v6h-2v-6zm-1.333 1.333h-2v4.667h2V8.666zM5.333 10h2v3.333h-2V10zM4 11.333H2v2h2v-2zM15.333 14H.667v1.333h14.666V14zm-2-13.333L13.9 2.1l1.434.566-1.434.565-.566 1.434-.566-1.434-1.434-.566 1.434-.565.566-1.434zM11.883 5l-.764-1.093-4.39 3.074-.383-.546-.765-1.092-1.092.765L.667 8.785l.764 1.092L5.254 7.2l1.147 1.638.021-.014 1.071-.75L11.883 5z"}})])
          )
        }
      }
    